<ng-container *ngIf="formControl">
  <mat-checkbox class="control-input" [formControl]="formControl" (blur)="onBlur()" [id]="id" [name]="name" [ngStyle]="textAlignStyle">
    <div class="yes-no-input-label">
      {{ label }}
    </div>
  </mat-checkbox>
  <app-control-error [control]="formControl" [offset]="-16"></app-control-error>
</ng-container>
